<template>
  <div class="download-center-page">
    <div class="download-center-wrap">
      <section class="download-hero">
        <div>
          <h2>下载中心</h2>
          <p>提供投标相关客户端、浏览器和远程协助工具下载，方便快捷。</p>
        </div>
      </section>

      <section class="download-tabs">
        <el-button
          v-for="tab in tabs"
          :key="tab.value"
          size="small"
          :type="activeTab === tab.value ? 'primary' : 'default'"
          :style="tabbarColor && activeTab === tab.value ? { backgroundColor: tabbarColor, borderColor: tabbarColor } : {}"
          :icon="tab.icon"
          @click="activeTab = tab.value"
        >
          {{ tab.label }}
        </el-button>
      </section>

      <section class="download-list-card">
        <div
          v-for="item in filteredDownloadList"
          :key="item.id"
          class="download-row"
        >
          <div class="download-icon" :class="item.type">
            <i :class="item.icon"></i>
          </div>
          <div class="download-info">
            <div class="download-title">{{ item.title }}</div>
            <div class="download-desc">{{ item.desc }}</div>
          </div>
          <el-button
            :style="tabbarColor ? { backgroundColor: tabbarColor, borderColor: tabbarColor } : {}"
            size="small"
            class="download-btn"
            @click="handleDownload(item)"
          >
            <i class="el-icon-download" style="color: #fff;"></i> 
          <span style="color: #fff;">下载</span>
          </el-button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadCenter',
  data() {
    return {
      activeTab: 'all',
      tabs: [
        { label: '全部资料', value: 'all', icon: 'el-icon-menu' },
        { label: 'CA工具', value: 'ca', icon: 'el-icon-key' },
        { label: '浏览器', value: 'browser', icon: 'el-icon-monitor' },
        { label: '远程工具', value: 'remote', icon: 'el-icon-connection' }
      ],
      downloadList: [
        {
          id: 1,
          title: 'ESSReader客户端',
          desc: 'ESSReaderClient V4.5.4（已授权），用于证书读取与电子签章',
          icon: 'el-icon-key',
          type: 'ca',
          url: 'https://mfile.vbidding.com/public-downloads/ca%2FESSPDFClient_SetupV4.5.4.rar'
        },
        {
          id: 2,
          title: '证书应用环境安装程序',
          desc: '证书应用环境安装程序 V3.8.6（信步云），CA证书运行依赖环境',
          icon: 'el-icon-cpu',
          type: 'ca',
          url: 'https://mfile.vbidding.com/public-downloads/ca%2F证书应用环境安装程序V3.8.6(信步云).zip'
        },
        // 新增投标客户端
        {
          id: 6,
          title: '投标客户端',
          desc: '投标专用客户端程序，支持投标文件制作与上传',
          icon: 'el-icon-s-platform',
          type: 'ca',
          url: 'https://mfile.vbidding.com/public-downloads/ca/%E6%8A%95%E6%A0%87%E5%AE%A2%E6%88%B7%E7%AB%AF.exe'
        },
        {
          id: 3,
          title: '谷歌浏览器',
          desc: '推荐使用 Chrome 浏览器访问平台，提升系统兼容性与操作体验',
          icon: 'el-icon-monitor',
          type: 'browser',
          url: 'https://mfile.vbidding.com/public-downloads/ca%2FChromeStandaloneSetup64.exe'
        },
        {
          id: 4,
          title: 'ToDesk远程控制',
          desc: '远程协助工具，用于问题排查、远程支持和操作指导',
          icon: 'el-icon-connection',
          type: 'remote',
          url: 'https://www.todesk.com/download.html'
        },
        {
          id: 5,
          title: '信步云补丁（libmskf.dll）',
          desc: '若CA证书助手安装后仍无法使用，请下载此补丁，解压后将 libmskf.dll 拷贝到 C:\\Program Files (x86)\\BJCAClient\\YunCertPlugin_XBY\\x86 目录下',
          icon: 'el-icon-paperclip',
          type: 'ca',
          url: 'https://mfile.vbidding.com/public-downloads/ca%2Flibmskf.rar'
        }
      ]
    }
  },
  computed: {
    tabbarColor() {
      return this.$channelMaterial.getTabbarColor() || ''
    },
    filteredDownloadList() {
      if (this.activeTab === 'all') return this.downloadList
      return this.downloadList.filter(item => item.type === this.activeTab)
    }
  },
  methods: {
    handleDownload(item) {
      window.open(item.url, '_blank')
    }
  }
}
</script>
<style scoped>
.download-center-page {
  min-height: 620px;
  padding: 24px 0 56px;
  background: #eef3f8;
}

.download-center-wrap {
  width: 860px;
  max-width: calc(100% - 32px);
  margin: 0 auto;
}

.download-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 26px;
  margin-bottom: 14px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 30, 80, 0.06);
}

.download-hero h2 {
  position: relative;
  margin: 0 0 10px;
  padding-left: 12px;
  color: #1d4f91;
  font-size: 18px;
  font-weight: 700;
}

.download-hero h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  width: 3px;
  height: 18px;
  background: #f5a623;
  border-radius: 2px;
}

.download-hero p {
  margin: 0;
  color: #667085;
  font-size: 13px;
}

.download-tabs {
  display: flex;
  gap: 12px;
  padding: 16px;
  margin-bottom: 14px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 30, 80, 0.06);
}

.download-list-card {
  overflow: hidden;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 30, 80, 0.06);
}

.download-row {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 70px;
  padding: 14px 18px;
  border-bottom: 1px solid #eef2f6;
}

.download-row:nth-child(even) {
  background: #f6f9fd;
}

.download-row:last-child {
  border-bottom: none;
}

.download-icon {
  width: 38px;
  height: 38px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  flex-shrink: 0;
}

.download-icon.ca {
  background: #d94841;
}

.download-icon.browser {
  background: #2f9bd7;
}

.download-icon.remote {
  background: #29a56b;
}

.download-info {
  flex: 1;
  min-width: 0;
}

.download-title {
  margin-bottom: 6px;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}

.download-desc {
  color: #6b7280;
  font-size: 12px;
  line-height: 1.4;
}

.download-btn {
  width: 74px;
  flex-shrink: 0;
  background: #164f93;
  border-color: #164f93;
}

.download-btn:not([style]) {
  background: #164f93;
  border-color: #164f93;
}
</style>
